import Vue from 'vue'
import Vuex from 'vuex'
import router from './router/'
const fb = require('./firebaseConfig.js')
const en = require('./lang/en.js')
const adminUser = require('./classes/admin/adminUser.js')
Vue.use(Vuex)
const logs = require("@/classes/logs/logs.js").Logs;
fb.auth.onAuthStateChanged(user => {
    logs.print(user)
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchUserProfile')
    } else {
        router.push("/login");
    }
    store.commit('loading', false)
    store.commit('loadingBG', false)
})
export const store = new Vuex.Store({
    state: {
        loading: true,
        loadingBG: true,
        fb: fb,
        breadcrumb: "",
        page_name: "",
        hasPageHelp: false,
        currentUser: null,
        images: {},
        notifications: {
            count: 0,
            player_no_content: {}
        },
        adminUser: adminUser.adminUser,
        lang: en.lang
    },
    actions: {
        fetchUserProfile({ commit, state }) {
            state.fb = fb
            state.adminUser = adminUser.adminUser
            state.adminUser.lang = state.lang
            state.adminUser.updateUser(fb, state.currentUser)
      
            //commit('setUserProfile', adminUser.adminUser)
        }
    },
    mutations: {
        page_name(state, val) {
            state.page_name = val
        },
        hasPageHelp(state, val) {
            state.hasPageHelp = val
        },
        loading(state, val) {
            state.loading = val
        },
        loadingBG(state, val) {
            state.loadingBG = val
        },
        reset_notifications(state) {
            state.notifications = {}
        },
        remove_notifications(state, val) {
            if (!val.key) return
            state.notifications.count = 0;
            delete state.notifications[val.key]//= false

            for (var key in state.notifications) {
                if (state.notifications[key] && key != "count" &&state.notifications[key].text )
                    state.notifications.count++
            }
        },
        add_notifications(state, val) {
            if (!val || !val.val || !val.key) return
            state.notifications[val.key] = val.val
            state.notifications.count = 0;
            for (var key in state.notifications) {

                if (state.notifications[key] && key != "count" &&state.notifications[key].text )
                    state.notifications.count++
                logs.print("key", key, state.notifications.count)
            }
            logs.print("state.notifications")
            console.dir(state.notifications)
        },
        images(state, val) {
            state.images = val
        },
        breadcrumb(state, val) {
            state.breadcrumb = val
        },
        setCurrentUser(state, val) {
            state.currentUser = val

        },
        setUserProfile(state, val) {
            state.userProfile = val
        }
    }
})
export default store